// extracted by css-extract-rspack-plugin
export default {"header":"header--tEsKM5oP8akkWnuj"};